import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"
import { BillingEnum, type BillingFormValues } from "./Billing.schema"

const commonAdhRoleConf = ({ disabled = true, hasCipCode = false }) => ({
  [BillingEnum.CIPCODE]: {
    displayOnlyValue: !hasCipCode,
    emptyDisplayValue: "Information non renseignée",
    disabled,
  },
  [BillingEnum.SIRET]: { disabled },
  [BillingEnum.ACTUALFINESSCODE]: { disabled },
  [BillingEnum.LASTFINESSCODE]: { disabled },
  [BillingEnum.CENTRALBUSINESSID]: { disabled },
  [BillingEnum.INTRACOMMUNITYVAT]: { disabled },
})

export const formRoleConf = (
  hasCipCode: boolean,
): RoleStrategy<
  Record<
    BillingFormValues & BillingEnum.CENTRALBUSINESSID,
    { disabled: boolean; displayOnlyValue?: boolean; emptyDisplayValue?: string }
  >
> => ({
  [ROLES.ADMIN]: {},
  [ROLES.ADHERENT_TEAM]: commonAdhRoleConf({ hasCipCode }),
  [ROLES.ADHERENT_HOLDER]: commonAdhRoleConf({ hasCipCode }),
})
